import "./_news-list-styles.scss";

import './news-list';
